import { render, staticRenderFns } from "./class-wise-performance-report.vue?vue&type=template&id=3a526ae2&scoped=true&"
import script from "./class-wise-performance-report.vue?vue&type=script&lang=js&"
export * from "./class-wise-performance-report.vue?vue&type=script&lang=js&"
import style0 from "./class-wise-performance-report.vue?vue&type=style&index=0&id=3a526ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a526ae2",
  null
  
)

export default component.exports